import { Link } from 'react-router-dom';
import logo from '../resources/logo.svg';
import { Facebook, Instagram, MessageSquare, Twitter } from 'lucide-react';
import { useSignInModal } from '../SignInModalContext';

function Footer() {
  const { openSignInModal } = useSignInModal();

  return (
    <footer className="text-gray-600 pt-8 pb-4 border-t">
      
        <div className="max-w-7xl mx-auto px-4">
          {/* Mobile Footer */}
          <div className="lg:hidden">
            <div className="flex items-center justify-center mb-6">
              <div className="flex items-center text-[#2476f2]">
                <img src={logo} alt="Website Logo" height="25" className="max-w-none h-8" />
              </div>
            </div>
            
            {/*
            <div className="flex justify-center space-x-4 mb-6">
              <a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">
                <Instagram className="h-5 w-5" />
              </a>
            </div>*/
            }
            
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <h3 className="text-sm font-semibold mb-2 text-gray-800">Quick Links</h3>
                <ul className="space-y-1 text-sm">
                  <li><Link to="/" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Home</Link></li>
                  <li><Link to="/search-results?localities=" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Browse Rooms</Link></li>
                  <li><button onClick={() => openSignInModal('/create-listing')}  className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">List Your Room</button></li>
                  <li><a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">How It Works</a></li>
                  <li><a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">About Us</a></li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-sm font-semibold mb-2 text-gray-800">Popular Cities</h3>
                <ul className="space-y-1 text-sm">
                  <li><Link to={'/sharehouses-in-sydney'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Sydney</Link></li>
                  <li><Link to={'/sharehouses-in-melbourne'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Melbourne</Link></li>
                  <li><Link to={'/sharehouses-in-brisbane'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Brisbane</Link></li>
                  <li><Link to={'/sharehouses-in-perth'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Perth</Link></li>
                  <li><Link to={'/sharehouses-in-adelaide'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Adelaide</Link></li>
                </ul>
              </div>
            </div>
            
            <div className="flex justify-center mb-6">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdn3_IVpqr99u5EQu8jdXYyvyW_axVEmPvJ06Zyup6g8PcMeg/viewform" className="flex items-center text-[#00b8d9] hover:text-[#24a1f2] transition-colors duration-200">
                <MessageSquare className="h-5 w-5 mr-2" />
                <span>Leave Feedback</span>
              </a>
            </div>
          </div>
          
          {/* Desktop Footer */}
          <div className="hidden lg:block">
            <div className="grid grid-cols-4 gap-8 mb-8">
              {/* Logo and Description */}
              <div>
                <div className="flex items-center mb-4">
                  <div className="flex items-center text-[#2476f2]">
                  <img src={logo} alt="Website Logo" height="25" className="max-w-none h-8" />
                  </div>
                </div>
                <p className="text-gray-600 mb-4">Free Australian flatmate finding service. No fees, subscriptions, or hidden paywalls. List or find sharehouses across Australia without limits.</p>
                <p className="text-gray-600 text-xs md:text-sm mb-2 md:mb-0 text-center md:text-left pt-0">© 2025 Propyn. All rights reserved.</p>
                {/*<div className="flex space-x-4 pt-4">
                  <a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">
                    <Facebook className="h-5 w-5" />
                  </a>
                  <a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">
                    <Twitter className="h-5 w-5" />
                  </a>
                  <a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">
                    <Instagram className="h-5 w-5" />
                  </a>
                </div>*/}


              </div>
              
              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4 text-gray-800">Quick Links</h3>
                <ul className="space-y-2">
                  <li><Link to="/" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Home</Link></li>
                  <li><Link to="/search-results?localities=" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Browse Rooms</Link></li>
                  <li><button onClick={() => openSignInModal('/create-listing')} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">List Your Room</button></li>
                  <li><a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">How It Works</a></li>
                  <li><a href="#" className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">About Us</a></li>
                </ul>
              </div>
              
              {/* Australian Cities */}
              <div>
                <h3 className="text-lg font-semibold mb-4 text-gray-800">Popular Cities</h3>
                <ul className="space-y-2">
                  <li><Link to={'/sharehouses-in-sydney'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Sydney</Link></li>
                  <li><Link to={'/sharehouses-in-melbourne'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Melbourne</Link></li>
                  <li><Link to={'/sharehouses-in-brisbane'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Brisbane</Link></li>
                  <li><Link to={'/sharehouses-in-perth'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Perth</Link></li>
                  <li><Link to={'/sharehouses-in-adelaide'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Adelaide</Link></li>
                  <li><Link to={'/sharehouses-in-goldcoast'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Gold Coast</Link></li>
                  <li><Link to={'/sharehouses-in-canberra'} className="text-gray-600 hover:text-[#2476f2] transition-colors duration-200">Canberra</Link></li>
                </ul>
              </div>
              
              {/* Feedback */}
              <div>
                <h3 className="text-lg font-semibold mb-4 text-gray-800">Get in Touch</h3>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSdn3_IVpqr99u5EQu8jdXYyvyW_axVEmPvJ06Zyup6g8PcMeg/viewform" className="flex items-center text-[#00b8d9] hover:text-[#24a1f2] transition-colors duration-200 mb-4">
                  <MessageSquare className="h-5 w-5 mr-2" />
                  <span>Leave Feedback</span>
                </a>
                <p className="text-gray-600 text-sm">We're constantly improving. Let us know how we can make Propyn better for you.</p>
              </div>
            </div>
          </div>
          
          {/* Bottom Footer - Both Mobile and Desktop */}
          <div className=" border-gray-600 pt-4 flex flex-col md:flex-row justify-between items-center sm:invisible">
            <p className="text-gray-600 text-xs md:text-sm mb-2 md:mb-0 text-center md:text-right">© 2025 Propyn. All rights reserved.</p>
          </div>
        </div>
      </footer>

  );
}

export default Footer; 